import { AfterViewInit, Directive, ElementRef, HostListener, inject, Renderer2 } from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { MaybeNull } from 'src/app/utils';
import { unsubscribeAll } from '../../app.helpers';
import { CurrentOperation, OperationInfo } from '../../long-operations/long-operations.interface';
import { OperationInfoService } from '../../long-operations/operation-info.service';

@Directive({
  selector: '[appLongOperation]',
})
export class LongOperationDirective implements AfterViewInit {
  public buttonId = '';

  private subscriptions$: Subscription[] = [];

  private renderer = inject(Renderer2);
  private operationInfoService = inject(OperationInfoService);
  private element = inject<ElementRef<HTMLButtonElement>>(ElementRef<HTMLButtonElement>);

  public ngAfterViewInit(): void {
    this.buttonId = this.element.nativeElement.getAttribute('data-test-id') ?? '';
    //  createButtonSpinner for each click
    this.operationInfoService.operationScheduled$.subscribe((item: OperationInfo | null) => {
      if (item?.spinner === 'button' && item.button?.id === this.buttonId) {
        this.createButtonSpinner();
      }
    });
  }

  @HostListener('click')
  @HostListener('window:keydown.enter')
  @HostListener('window:keydown.meta.enter')
  public clickEvent(): void {
    this.subscriptions$.push(
      this.operationInfoService.isLoadingButtonSpinner$
        .pipe(filter(({ operation }: CurrentOperation) => operation.button?.id === this.buttonId))
        .subscribe((operation: CurrentOperation) => {
          setTimeout(() => {
            operation.status
              ? this.renderer.setAttribute(this.element.nativeElement, 'disabled', 'true')
              : this.renderer.removeAttribute(this.element.nativeElement, 'disabled');
          });
          const spinner: MaybeNull<HTMLElement> = document.querySelector('#local-button-spinner');

          if (!operation.status && spinner) {
            spinner.remove();
          }
        }),
    );
  }

  public ngOnDestroy(): void {
    unsubscribeAll(this.subscriptions$);
  }

  public appendSpinnerToButton(buttonId: string): void {
    const button: MaybeNull<HTMLElement> = document.getElementById(buttonId);
    const close: MaybeNull<HTMLElement> = document.getElementById('modal-btn-close');
    const cross: MaybeNull<HTMLElement> = document.getElementById('modal-btn-close-cross');

    if (button) {
      const spinner = this.renderer.createElement('span') as HTMLSpanElement;
      this.renderer.setAttribute(close, 'disabled', 'true');
      this.renderer.setAttribute(cross, 'disabled', 'true');
      this.renderer.addClass(spinner, 'spinner-border');
      this.renderer.addClass(spinner, 'spinner-border-sm');
      this.renderer.addClass(spinner, 'spinner-position');
      this.renderer.setAttribute(spinner, 'role', 'status');
      this.renderer.setAttribute(spinner, 'aria-hidden', 'true');
      this.renderer.setAttribute(spinner, 'id', 'local-button-spinner-' + buttonId);

      this.renderer.appendChild(button, spinner);
    }
  }

  private createButtonSpinner(): void {
    const spinner: HTMLElement = document.createElement('span');

    spinner.classList.add('spinner-border', 'spinner-border-sm', 'spinner-position');
    spinner.setAttribute('role', 'status');
    spinner.setAttribute('aria-hidden', 'true');
    spinner.setAttribute('data-test-id', 'local-button-spinner');
    spinner.setAttribute('id', 'local-button-spinner');
    this.element.nativeElement.insertAdjacentElement('afterbegin', spinner);
  }
}
